export const fileUploading = {
  attach_file: "ფაილის ატვირთვა",
  uploading_desc:
    "დასაშვებია {{fileCount}} ფაილის ატვირთვა, ჯამური ზომა {{fileSize}}. დიდი ზომის ფაილი უნდა გააგზავნოთ ელ ფოსტაზე: <anchor>{{email}}</anchor>",
  file_counter: "დასაშვებია {{fileCount}} ფაილის ატვირთვა",
  choose_or_drop: "აირჩიეთ ან ჩააგდეთ ფაილი",
};
